import script from "./infoModule.vue?vue&type=script&setup=true&lang=js"
export * from "./infoModule.vue?vue&type=script&setup=true&lang=js"

import "./infoModule.vue?vue&type=style&index=0&id=2dfcafcc&lang=scss&scoped=true"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dfcafcc"]])

export default __exports__